import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("EntregaZERealizada");
const crud = rpcCrudService<models.EntregaZERealizada, models.EntregaZERealizadaDTO>(controller);

const otros = {
    Query: async (filtro: models.FiltroEntregaZE): Promise<models.EntregaZERealizadaDTO[]> => await controller("Query", {}, filtro),

    GetGuias: async (IdEntrega:number): Promise<models.GuiaDTO[]> => await controller("GetGuias",{ IdEntrega }),

}

export const EntregaZERealizada = cacheResource({
    ...crud,
    ...otros
}, {
        Query: true,
        GetGuias: true
    }, {

    })


// WEBPACK FOOTER //
// ./app/resources/items/entregazerealizada.tsx